/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePrinterRequest
 */
export interface UpdatePrinterRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePrinterRequest
     */
    model: string;
}

/**
 * Check if a given object implements the UpdatePrinterRequest interface.
 */
export function instanceOfUpdatePrinterRequest(value: object): value is UpdatePrinterRequest {
    if (!('model' in value) || value['model'] === undefined) return false;
    return true;
}

export function UpdatePrinterRequestFromJSON(json: any): UpdatePrinterRequest {
    return UpdatePrinterRequestFromJSONTyped(json, false);
}

export function UpdatePrinterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePrinterRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'model': json['model'],
    };
}

export function UpdatePrinterRequestToJSON(json: any): UpdatePrinterRequest {
    return UpdatePrinterRequestToJSONTyped(json, false);
}

export function UpdatePrinterRequestToJSONTyped(value?: UpdatePrinterRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'model': value['model'],
    };
}

